<template>
  <BaseLayout>
    <InnerLoading :loading="false" class="h-full w-full min-h-full bg-success-gray">
      <div class="flex items-center justify-center bg-red-darkness-claro">
        <div class="flex flex-col w-full sm:w-2/3 xl:w-1/2 pb-10 h-auto px-5 sm:px-10 lg:px-20 py-3 gap-4 items-start">
          <div class="mdn-IconGroup mdn-IconGroup--inverse">
            <span class="mdn-Icon-check mdn-Icon--md"></span>
          </div>
          <mdn-heading size="sm" :level="2" inverse>Solicitação concluída</mdn-heading>
          <mdn-text class="font-medium" isInverse>Em instantes você vai receber um SMS confirmando a migração e ativação do seu novo plano Claro Controle.</mdn-text>
          <div v-if="successData.pix" class="flex flex-row justify-center items-center">
            <span class="text-white mdn-Icon-circulo-exclamacao mdn-Icon--md"></span>
            <mdn-text id="text-success-next-billing-card-reminder" class="text-white-500 font-medium ml-2" isInverse>
              Lembrando que as próximas contas continuarão sendo cobradas no seu cartão cadastrado {{ successData.cardBrand }} final {{ successData.cardLast }}.
            </mdn-text>
          </div>
        </div>
      </div>

      <div class="flex items-center justify-center">
        <div class="flex flex-col py-5 sm:px-10 lg:px-20 w-full sm:w-2/3 xl:w-1/2 justify-center gap-5">
          <div class="px-5">
            <mdn-heading class="text-lg font-bold" :level="3">Resumo</mdn-heading>
            <mdn-text>
              Em breve você vai poder aproveitar os seguintes benefícios:
            </mdn-text>
          </div>

          <OfferDetailContext isSuccess :offer="offer">
            <div class="flex flex-col px-5 gap-3">
              <div class="flex flex-col justify-center">
                <mdn-text class="font-bold">Número a ser migrado</mdn-text>
                <div class="flex flex-row gap-2 items-center">
                  <span class="mdn-Icon-celular mdn-Icon--md text-red-600"></span>
                  <mdn-text id="text-success-user-msisdn">{{formated.msisdn}}</mdn-text>
                </div>
              </div>
              <div class="flex flex-col justify-center">
                <mdn-text class="font-bold">Valor</mdn-text>
                <div class="flex flex-row gap-2 items-center">
                  <span class="mdn-Icon-cartao-cifrao-circulo mdn-Icon--md text-red-600"></span>
                  <mdn-text id="text-success-montly-price" >R$ {{offer.price?.adesao.full}}/mês</mdn-text>
                </div>
              </div>
              <div class="flex flex-col justify-center">
                <mdn-text class="font-bold">{{tituloFormaDePagamento}}</mdn-text>
                <div class="flex flex-row gap-2 items-center">
                  <span class="mdn-Icon--md text-red-600" :class="[iconeFormaDePagamento]"></span>
                  <mdn-text id="text-success-payment-method">{{ valorFormaDePagamento }}</mdn-text>
                </div>
              </div>
              <div v-if="!!nextBillingDate" class="flex flex-col justify-center">
                <mdn-text class="font-bold">Data da próxima cobrança</mdn-text>
                <div class="flex flex-row gap-2 items-center">
                  <span class="mdn-Icon-calendario mdn-Icon--md text-red-600"></span>
                  <mdn-text id="text-success-next-billing-date">{{nextBillingDate}}</mdn-text>
                </div>
              </div>
            </div>
          </OfferDetailContext>

        </div>
      </div>

    </InnerLoading>
  </BaseLayout>
</template>

<script>
import { manageConfirmationMixin, manageTransactionIdMixin } from 'business/payment/mixins'
import { formatMsisdn } from 'common/format'
import { singleOfferMixin } from '@/business/offers/mixins'
import { MdnText, MdnHeading } from 'mondrian-vue'
import OfferDetailContext from '../components/OfferDetailContext.vue'
import InnerLoading from '../components/InnerLoading.vue'
import { loadUserDataMixin } from 'business/user/mixins'
import { onlyNumbers } from '@brazilian-utils/helper-only-numbers'
import 'dayjs/locale/pt-br'
import dayjs from 'dayjs'
import { clearStorage } from '../business/store'
dayjs.locale('pt-br')

export default {
  name: 'page-success',
  title: 'Sucesso',
  components: { MdnText, MdnHeading, OfferDetailContext, InnerLoading },
  props: {
    type: String
  },
  mixins: [
    singleOfferMixin,
    manageConfirmationMixin,
    manageTransactionIdMixin,
    loadUserDataMixin
  ],
  data: () => ({
    successData: {
      pix: false,
      cardBrand: '',
      cardLast: '',
      msisdn: '',
      paymentDate: ''
    }
  }),
  methods: {
    async loadData () {
      try {
        const confirmation = await this.loadSuccessfulTransaction()
        this.successData = {
          ...confirmation,
          msisdn: formatMsisdn(onlyNumbers(confirmation.msisdn))
        }
      } catch (err) {
        this.$tracker.error(err)
        this.$router.replace({
          name: 'page-error'
        })
      }
    }
  },
  computed: {
    formated () {
      return {
        msisdn: formatMsisdn(onlyNumbers(this.userData.msisdn))
      }
    },
    nextBillingDate () {
      return dayjs(this.successData.paymentDate).add(1, 'month').format('DD [de] MMMM [de] YYYY')
    },
    tituloFormaDePagamento () {
      return this.successData.pix ? 'Método de pagamento' : 'Cartão utilizado no pagamento'
    },
    valorFormaDePagamento () {
      return this.successData.pix ? 'Pix' : `${this.successData.cardBrand} final ${this.successData.cardLast}`
    },
    iconeFormaDePagamento () {
      return this.successData.pix ? 'mdn-Icon-pix' : 'mdn-Icon-cartao-de-credito'
    }
  },
  async mounted () {
    if (this.type !== 'CHANGE_PLAN') {
      await this.loadData()
    }

    await clearStorage(true)
  }
}
</script>
